import sprks from './Users/sprks'
import buczy from './Users/buczy'
import srrnt from './Users/srrnt'
//import wldrn from './Users/wldrn'
import brrck from './Users/brrck'
import dwrds from './Users/dwrds'
import tlrp from './Users/tlrp'
import almdc from './Users/almdc'

const shuffle = (array) => {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

const users = [
  sprks,
  buczy,
  srrnt,
  //wldrn,
  brrck,
  dwrds,
  tlrp,
  almdc,
  // {
  //   name: undefined,
  //   url: undefined,
  //   avatar: undefined,
  //   seen: false,
  //   anonymous: true
  // },
]

export default shuffle(users)



// WEBPACK FOOTER //
// ./src/Data/users.js